<template>
  <div>
    <Modal
      v-model="modal"
      :title="type == 'add' ?$t('add'):$t('edit')"
      :mask-closable="false"
      width="800"
      @on-cancel="cancel"
    >
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" inline :label-width="90" label-colon>
          <Tabs :value="tabs" @on-click="ontabs">
            <TabPane :label="$t('Langue.zn')" name="1">
              <div class="item">
                <FormItem prop="zh-cn_title" :label="$t('cms_email.title')">
                  <Input
                    type="text"
                    v-model="form['zh-cn_title']"
                    :placeholder="$t('cms_email.int_title')"
                  ></Input>
                </FormItem>
                <FormItem prop="zh-cn_mailname" :label="$t('cms_email.name')">
                  <Input
                    type="text"
                    v-model="form['zh-cn_mailname']"
                    :placeholder="$t('cms_email.int_name')"
                  ></Input>
                </FormItem>
                <FormItem prop="zh-cn_content" :label="$t('cms_email.content')">
                  <Input
                    v-model="form['zh-cn_content']"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    :placeholder="$t('cms_email.int_content')"
                  />
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.tw')" name="2">
              <div class="item">
                <FormItem prop="zh-tw_title" :label="$t('cms_email.title')">
                  <Input type="text" v-model="form['zh-tw_title']" placeholder="請輸入郵件標題"></Input>
                </FormItem>
                <FormItem prop="zh-tw_mailname" :label="$t('cms_email.name')">
                  <Input type="text" v-model="form['zh-tw_mailname']" placeholder="請輸入郵件名字"></Input>
                </FormItem>
                <FormItem prop="zh-tw_content" :label="$t('cms_email.content')">
                  <Input
                    v-model="form['zh-tw_content']"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="請輸入郵件內容"
                  />
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.en')" name="3">
              <div class="item">
                <FormItem prop="en_title" :label="$t('cms_email.title')">
                  <Input
                    type="text"
                    v-model="form.en_title"
                    placeholder="Please enter the mail title"
                  ></Input>
                </FormItem>
                <FormItem prop="en_mailname" :label="$t('cms_email.name')">
                  <Input
                    type="text"
                    v-model="form.en_mailname"
                    placeholder="Please enter the mail name"
                  ></Input>
                </FormItem>
                <FormItem prop="en_content" :label="$t('cms_email.content')">
                  <Input
                    v-model="form.en_content"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="Please enter the message content"
                  />
                </FormItem>
              </div>
            </TabPane>
          </Tabs>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    contactUsObj: Object,
    type: String
  },
  data () {
    return {
      tabs: '1',
      form: {
        mailinfo_id: "",
        en_content: "",
        en_title: "",
        en_mailname: "",
        "zh-cn_content": "",
        "zh-cn_title": "",
        "zh-cn_mailname": "",
        "zh-tw_title": "",
        "zh-tw_content": "",
        "zh-tw_mailname": ""
      },
      ruleInline: {
        'zh-cn_title': [
          {
            required: true,
            message: this.$t('cms_email.int_title'),
            trigger: "blur"
          }
        ],
        'zh-cn_mailname': [
          {
            required: true,
            message: this.$t('cms_email.int_name'),
            trigger: "blur"
          }
        ],
        'zh-cn_content': [
          {
            required: true,
            message: this.$t('cms_email.int_content'),
            trigger: "blur"
          }
        ],
        'zh-tw_title': [
          {
            required: true,
            message: '請輸入郵件標題',
            trigger: "blur"
          }
        ],
        'zh-tw_mailname': [
          {
            required: true,
            message: '請輸入郵件名字',
            trigger: "blur"
          }
        ],
        'zh-tw_content': [
          {
            required: true,
            message: '請輸入郵件內容',
            trigger: "blur"
          }
        ],
        en_title: [
          {
            required: true,
            message: 'Please enter the mail title',
            trigger: "blur"
          }
        ],
        en_mailname: [
          {
            required: true,
            message: 'Please enter the mail name',
            trigger: "blur"
          }
        ],
        en_content: [
          {
            required: true,
            message: 'Please enter the message content',
            trigger: "blur"
          }
        ]
      },
    }

  },
  mounted () {

  },
  methods: {
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    ontabs (item) {
      this.tabs = item
    },
    submit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          //   this.$base.showLoading();
          //   this.$request.sendPost(
          //     'mailinfo/upd',
          //     this.form,
          //     (success, data, error) => {
          //       this.$base.hideLoading();
          //       if (!success) return this.$base.alertErr(error.errmsg);
          //       this.cancel()
          //       this.$base.msgSuccess(this.$t("op_ok"));
          //       this.$refs.table.getLoad();
          //     }
          //   );
        } else {
          this.error()
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 20px 0 20px 10%;
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/infoItem/module/itemInfo_edit.vue